import { call, put, takeLatest, select } from "redux-saga/effects";
import { postFees } from "./Api";
import actionTypes from "../actions/actionTypes";
import {
  fetchSummarySuccessAction,
  fetchSummaryFailedAction
} from "actions/summaryActions";
import {
  selectCurrentStateAbbr,
  selectFieldsResponse,
  selectFieldDetails
} from "selector/initializeSelector";
import { apiRequestFailureAction } from "actions/requestActions";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";
import fetchSaga from "./fetchSaga";
import { fetchWorkItemPDF } from "./Api";
import { openUrl } from "actions/iframeActions";

function* fetchSummarySaga() {
  try {
    const { messageHeader } = yield select(selectFieldsResponse);
    const fields = yield select(selectFieldDetails);
    const state = yield select(selectCurrentStateAbbr);
    const body = { messageHeader, fields };

    const response = yield call(fetchSaga, postFees, { state, body });
    yield put(fetchSummarySuccessAction(response.fees));
  } catch (error) {
    yield put(fetchSummaryFailedAction(error));
  }
}

function* generatePDFReportSaga({ payload: workItemId }) {
  yield put(showLoader());
  let args = { workItemId: workItemId };
  // let args = {workItemId: "5bf5808977c07d003b9634bc"};
  const response = yield call(fetchSaga, fetchWorkItemPDF, args, true);

  let blob = yield call(getBlob, response);
  let url = window.URL.createObjectURL(blob);
  yield put(hideLoader());
  if (blob.size === 4096) {
    let message = {
      messages: [
        {
          key: null,
          messageText:
            "PDF document is not yet created please try later to view the report",
          type: "warning"
        }
      ]
    };
    yield put(apiRequestFailureAction(message));
  } else {
    yield put(openUrl(url));
  }
}

function getBlob(response) {
  let blob = response.blob().then(data => {
    return new Blob([data], { type: "application/pdf" });
  });
  return blob;
}

export const SummarySagas = [
  takeLatest(actionTypes.FETCH_SUMMARY, fetchSummarySaga),
  takeLatest(actionTypes.WORK_ITEM_PDF_REPORT, generatePDFReportSaga)
];
